export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'ABOUT',
  headLine: 'EDDIE LEE',
  description: 'Also called as Junsoeng. I\'m a recent graduate of Queens College CUNY with Bachelor\'s degree in CS. I\'m currently working in Antra Inc. as Frontend intern developer. I enjoy solving challenge questions from leetcode.If you would like to know more about me click \'Get started\'!',
  buttonLabel: 'Get started',
  imgStart: false,
  img: require('../../images/profile.jpg').default,
  alt: 'Car',
  dark: true,
  primary: true,
  darkText: false
}

export const homeObjThree = {
  id: 'experience',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'EXPERIENCE',
  headLine: 'Frontend Developer(Intern) at Antra',
  description: 'Currently working for Antra as part of a team to manipulate websites for dynamic interfaces.',
  buttonLabel: 'For more',
  imgStart: false,
  img: require('../../images/svg-5.svg').default,
  alt: 'Paper',
  dark: false,
  primary: false,
  darkText: true
}
